import toastr from "toastr";
import { getDirection, translate, translateMessage } from "./language_helper";

/**
 * Drop-in replacement for `import toastr from "toastr"`.
 *
 * Toasts are raised with messages that come straight from the API
 * (`res.message`, `error.response.data.message`), so the message and the
 * optional title are localised before toastr renders them. Unknown messages
 * are passed through untouched.
 */

const localize = (method) => (message, title, options) => {
  const localizedMessage = translateMessage(message);
  const localizedTitle =
    typeof title === "string" && title.trim() ? translate(title) : title;

  toastr.options = {
    ...(toastr.options || {}),
    rtl: getDirection() === "rtl",
  };

  return toastr[method](localizedMessage, localizedTitle, options);
};

const LocalizedToastr = new Proxy(toastr, {
  get(target, prop) {
    if (prop === "success" || prop === "error" || prop === "warning" || prop === "info") {
      return localize(prop);
    }
    const value = Reflect.get(target, prop);
    return typeof value === "function" ? value.bind(target) : value;
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
});

export default LocalizedToastr;
